import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';
import { useAppStoreDispatch } from '../../../store';
import { toggleDrawer } from '../../app/store';
import { removeActivePortal } from '../../portal/store';

interface ButtonWithCloseProps {
  children: React.ReactNode;
  portalId: number;
}

function ButtonWithClose({ children, portalId }: ButtonWithCloseProps) {
  const dispatch = useAppStoreDispatch();
  const navigate = useNavigate();
  return (
    <Button
      variant="outlined"
      color="inherit"
      size="small"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        dispatch(toggleDrawer(false));
        navigate(`/portal/${portalId}`);
      }}
      sx={{ display: 'flex', gap: 1, justifyContent: 'space-between', textTransform: 'none', px: 1 }}
    >
      <Box component="span" sx={{ flex: 1 }}>{children}</Box>
      <Chip
        label="X"
        size="small"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          dispatch(removeActivePortal({ id: portalId }));
        }}
        sx={{ height: '20px', minWidth: '20px', '& .MuiChip-label': { px: 0.5 } }}
      />
    </Button>
  );
}

export default ButtonWithClose;
